<template>
  <ElConfigProvider :locale="zhCn">
    <router-view :key="$route.fullPath" />
  </ElConfigProvider>
</template>

<script setup lang="ts">
import { DEFAULT_SERVICE_ID, initClinkWebChat } from '@shared/util/kf5Support'
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/lib/locale/lang/zh-cn'

import { onMounted } from 'vue'
onMounted(() => {
  initClinkWebChat(DEFAULT_SERVICE_ID)
})
</script>

<style lang="scss">
@import 'element-plus/dist/index.css';
@import '@style/main';

#app {
  width: 100%;
  height: 100%;
  color: $dark;
  background: $page-bg;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#tinet-chat-visitor {
  display: none;
}
</style>
